import axios from 'axios'
import Vue from 'vue'
import store from '@/store'
import { has, get, each } from 'lodash'
import OAuthClient from "@/helpers/oauth";

import {span} from './../tracer'
import { NULL_UID } from '../../constants'

const api = axios.create()

api.updateBaseUrl = (baseUrl) => {
    api.defaults.baseURL = baseUrl
}

api.interceptors.request.use(function (config) {
    const token = OAuthClient.getToken()

    config.headers.Authorization = `Bearer ` + get(token, 'raw')
    config.headers['request-id'] = span._generateUUID()
    config.headers['positionid'] = store.getters['e/users/currentPositionId']
    if (!config.headers['organizationid']) {
        config.headers['organizationid'] = store.getters['e/users/currentOrganizationId']
    }
    config.headers['span-id'] = span.uuid()
    config.headers['trace-id'] = span._generateUUID()

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (get(error, 'response.status') === 401) {
            store.dispatch('e/users/forceLogoutFromApp')
            return Promise.reject(error)
        }
        let messageList = []
        if (has(error, 'response.data.title') || has(error, 'response.data.detail')) {

            if (has(error, 'response.data.title')) {
                messageList.push(`<b>${error.response.data.title}</b>:`)
            }
            if (has(error, 'response.data.detail')) {
                messageList.push(error.response.data.detail)
            }
        } else if (has(error, 'response.data.errors')) {
            each(get(error, 'response.data.errors'), item => {
                messageList.push(`<b>${item.name}</b>: ${item.description}<br />`)
            })
        } else if (has(error, 'response.data.message')) {
            messageList.push(get(error, 'response.data.message'))
        } else {
            messageList.push(`Ошибка... попробуйте позже`)
        }

        (new Vue()).$buefy.toast.open({
            duration: 7000,
            message: messageList.join(' '),
            position: 'is-bottom',
            type: 'is-danger'
        })

        return Promise.reject(error)
    }
)

export default api
